// Social link validation patterns
export const socialLinkValidationPatterns = {
  linkedin: /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/[a-zA-Z0-9\-_]+/,
  twitter: /^(http(s)?:\/\/)?([\w]+\.)?(x\.com|twitter\.com)\/[a-zA-Z0-9_]+/,
  facebook: /^(http(s)?:\/\/)?([\w]+\.)?facebook\.com\/[a-zA-Z0-9.]+/,
  instagram: /^(http(s)?:\/\/)?([\w]+\.)?instagram\.com\/[a-zA-Z0-9_.]+/,
  dribbble: /^(http(s)?:\/\/)?([\w]+\.)?dribbble\.com\/[a-zA-Z0-9\-_]+/,
  github: /^(http(s)?:\/\/)?([\w]+\.)?github\.com\/[a-zA-Z0-9\-_]+/,
};

// Social link validation messages
export const socialLinkValidationMessages = {
  linkedin: 'Invalid LinkedIn Profile URL',
  twitter: 'Invalid X Profile URL',
  facebook: 'Invalid Facebook Profile URL',
  instagram: 'Invalid Instagram Profile URL',
  dribbble: 'Invalid Dribbble Profile URL',
  github: 'Invalid GitHub Profile URL',
};

// Default social links configuration
export const defaultSocialLinks = [
  {
    name: 'linkedin',
    title: 'LinkedIn',
    placeholder: 'https://linkedin.com/in/your-profile',
  },
  {
    name: 'twitter',
    title: 'X',
    placeholder: 'https://x.com/your-handle',
  },
  {
    name: 'facebook',
    title: 'Facebook',
    placeholder: 'https://facebook.com/your-profile',
  },
  {
    name: 'instagram',
    title: 'Instagram',
    placeholder: 'https://instagram.com/your-handle',
  },
  {
    name: 'dribbble',
    title: 'Dribbble',
    placeholder: 'https://dribbble.com/your-profile',
  },
  {
    name: 'github',
    title: 'GitHub',
    placeholder: 'https://github.com/your-username',
  },
];

// Validation function for social links
export const validateSocialLink = (name: string, value: string): string | undefined => {
  if (!value.trim()) return undefined; // Empty values are allowed

  const pattern = socialLinkValidationPatterns[name as keyof typeof socialLinkValidationPatterns];
  const message = socialLinkValidationMessages[name as keyof typeof socialLinkValidationMessages];

  if (pattern && !pattern.test(value)) {
    return message;
  }

  return undefined;
};
